import { mailingConstants as C } from "../actions/constants";

const initialState = {
    mailing: [],
    mailingObj: null,
    sending: false,
    saving: false,
    loading: false,
    detailLoading: false,
    sent: false,
    saved: false,
    message: "",
    error: "",
};

export default function mailingReducer(state = initialState, action) {
    switch (action.type) {
        case C.SEND_MAILING_REQUEST:
            return {
                ...state,
                sending: true,
                sent: false,
                message: "",
                error: "",
            };

        case C.SEND_MAILING_SUCCESS:
            return {
                ...state,
                sending: false,
                sent: true,
                message: action.payload?.message || "Рассылка отправлена",
                error: "",
            };

        case C.SEND_MAILING_FAILURE:
            return {
                ...state,
                sending: false,
                sent: false,
                message: "",
                error: action.payload?.error || "Ошибка отправки рассылки",
            };

        case C.ADD_MAILING_REQUEST:
            return {
                ...state,
                saving: true,
                saved: false,
                message: "",
                error: "",
            };

        case C.ADD_MAILING_SUCCESS:
            return {
                ...state,
                saving: false,
                saved: true,
                mailingObj: action.payload?.mailing || state.mailingObj,
                message: action.payload?.message || "Рассылка сохранена",
                error: "",
            };

        case C.ADD_MAILING_FAILURE:
            return {
                ...state,
                saving: false,
                saved: false,
                message: "",
                error: action.payload?.error || "Ошибка сохранения рассылки",
            };

        case C.GET_MAILING_REQUEST:
            return {
                ...state,
                loading: true,
                error: "",
            };

        case C.GET_MAILING_SUCCESS:
            return {
                ...state,
                loading: false,
                mailing: action.payload?.mailing || [],
                error: "",
            };

        case C.GET_MAILING_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || "Ошибка загрузки рассылок",
            };

        case C.GET_BY_ID_MAILING_REQUEST:
            return {
                ...state,
                detailLoading: true,
                mailingObj: null,
                error: "",
            };

        case C.GET_BY_ID_MAILING_SUCCESS:
            return {
                ...state,
                detailLoading: false,
                mailingObj: action.payload?.mailing || null,
                error: "",
            };

        case C.GET_BY_ID_MAILING_FAILURE:
            return {
                ...state,
                detailLoading: false,
                mailingObj: null,
                error: action.payload?.error || "Ошибка загрузки рассылки",
            };

        case C.CLEAR_MAILING_STATUS:
        case C.SET_CLOSE_ALERT:
            return {
                ...state,
                sent: false,
                saved: false,
                message: "",
                error: "",
            };

        default:
            return state;
    }
}